import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Divider, HStack, Text, VStack } from "native-base";
import { formatDateTime } from "@madmedical/utils";
import { useTranslation } from "@madmedical/i18n";
import useResponsive from "../../util/useResponsive";
import { cropFilename } from "../../util/strings";
import PressableLink from "../../atoms/PressableLink";
import { useRouteNavigate } from "../../providers/routing";
import ActionButton from "../ActionButton";
import useDownloadPreview from "../../util/useDownloadPreview";
const DocumentListItem = ({ document, onDeletePress, withoutAction = false, }) => {
    const navigate = useRouteNavigate();
    const { download, isDownloading } = useDownloadPreview();
    const { isSmallScreen } = useResponsive();
    const { t } = useTranslation();
    const handleViewPress = () => {
        navigate("document", { documentId: document.id });
    };
    if (isDownloading) {
        // TODO: Spinner
    }
    return (_jsx(PressableLink, Object.assign({ route: "document", params: { documentId: document.id } }, { children: _jsxs(HStack, Object.assign({ justifyContent: "space-between", alignItems: "center", bgColor: "white", minWidth: "full", borderBottomWidth: 1, borderColor: "gray.100", px: 4, py: 5 }, { children: [_jsxs(VStack, { children: [_jsx(HStack, Object.assign({ mr: 10, space: 1.5, mb: 1 }, { children: _jsx(Text, Object.assign({ numberOfLines: 1 }, { children: cropFilename(document.filename, isSmallScreen ? 20 : 40) })) })), _jsx(HStack, Object.assign({ space: 1, divider: _jsx(Divider, { orientation: "vertical", bg: "gray.100" }) }, { children: _jsx(Text, Object.assign({ color: "gray.600", fontSize: "xs" }, { children: formatDateTime(document.createdAt) })) }))] }), !withoutAction && (_jsx(Box, Object.assign({ ml: "auto" }, { children: _jsx(ActionButton, { actions: [
                            {
                                text: t("view"),
                                iconName: "documentView",
                                onPress: handleViewPress,
                            },
                            {
                                text: t("download"),
                                iconName: "documentDownload",
                                onPress: () => {
                                    void download(document);
                                },
                            },
                            {
                                text: t("delete"),
                                iconName: "trashCan",
                                onPress: () => {
                                    onDeletePress === null || onDeletePress === void 0 ? void 0 : onDeletePress(document.id);
                                },
                            },
                        ] }) })))] })) })));
};
export default DocumentListItem;
